module.exports = __webpack_public_path__ + "static/img/ald.e4b284b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ald.jpg
// module id = uZyR
// module chunks = 1